export class CreatePersonaCuentaContableRequest{
  public idCuentaContable!:number
  public idPersona!:number
  public activo!: boolean
  public descripcion!: string
}
